import { render, staticRenderFns } from "./StoreDecorationTemplateDialog.vue?vue&type=template&id=280dc9f2&scoped=true&"
import script from "./StoreDecorationTemplateDialog.vue?vue&type=script&lang=js&"
export * from "./StoreDecorationTemplateDialog.vue?vue&type=script&lang=js&"
import style0 from "./StoreDecorationTemplateDialog.vue?vue&type=style&index=0&id=280dc9f2&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280dc9f2",
  null
  
)

export default component.exports